window.__EP_SETTINGS__ = {
  BASE_URL_API: 'http://localhost:8080/api',
  API_KEY: 'local',
  SOCKET_URL: 'ws://localhost:8080/api/ws/',

  ENDPOINTS: {
    GET_SETTINGS: '/v1/settings/country/{{ country }}',
    GENERATE_ACCESS_TOKEN: '/v1/authentication/generateAccessToken',
    CREATE_PO: '/v1/purchaseOrders',
    GET_PO_DETAILS: '/v1/purchaseOrders/{{ poUid }}',
    CREATE_PAYMENT_TXN: '/v1/paymentTransactions',
    RETRY_PAYMENT_TXN: '/v1/paymentTransactions/retry',
    UPDATE_TXN_STATUS: '/v1/paymentTransactions/{{ transactionUid }}/updateTransactionStatus'
  }
}
